import type { Theme } from '@mui/material';
// import type { Components } from '@mui/material/styles';

export default function MUITableRow(theme: Theme) /* : Components['MuiTableRow'] */ {
  return {
    // defaultProps: {},
    styleOverrides: {
      root: {
        '&.Mui-selected': {
          backgroundColor: theme.palette.action.selected,
          '&:hover': {
            backgroundColor: theme.palette.action.hover,
          },
        },
      },
    },
    // variants: [],
  };
}
